/**
 * This file is part of ONP.
 *
 * Copyright (c) 2013 Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Andrey Tkachenko <andrey.tkachenko@opensoftdev.ru>
 */

define(['jquery', 'underscore'], function($, _) {
    return {
        deepClone: function(source) {
            var _this = this;
            if (!_.isObject(source)) {
                return source;
            }

            var target = _.isArray(source) ? [] : {};
            _.each(source, function(item, key) {
                target[key] = _this.deepClone(item);
            });

            return target;
        },

        truncate: function(str, length, separator) {
            if (length && str.length > length) {
                separator = separator || '...';
                return str.slice(0, length - 1) + separator;
            }
            return str;
        },

        replace: function(str, params) {
            return _.reduce(
                params,
                function(acc, value, index) {
                    return acc.replace(':' + index, value);
                },
                str
            );
        },

        randomInt: function randomInt() {
            return Math.ceil(100 * Math.random());
        },

        iterateAsync: function(start, end, iterateCallback, part) {
            return new Promise(function(resolve, reject) {
                part = part || 1;
                var index = start;

                var step = function() {
                    if (index < end) {
                        var partEnd = index + part;
                        partEnd = partEnd > end ? end : partEnd;

                        while (index < partEnd) {
                            iterateCallback(index);
                            index++;
                        }

                        setTimeout(function() {
                            step();
                        }, 0);
                    } else {
                        resolve();
                    }
                };
                step();
            });
        },

        /**
         * Replace new lines by br tag.
         *
         * @param {string} str
         * @param {bool} isXhtml
         * @returns {string}
         */
        nl2br: function(str, isXhtml) {
            var breakTag = isXhtml === true ? '<br/>' : '<br>';

            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },

        /**
         * Determines if a value is contained by a range. boundary parameters need not be sorted by lower or upper
         * @param {number} value - number to test against the range
         * @param {number} rangeBoundary1 - edge bound of the range
         * @param {number} rangeBoundary2 - edge bound of the range
         * @returns {boolean} true if the number was contained by the range
         */
        between: function(value, rangeBoundary1, rangeBoundary2) {
            // validate inputs for being a number, then perform boundary checks
            var result =
                isNaN(value) || isNaN(rangeBoundary1) || isNaN(rangeBoundary2)
                    ? NaN
                    : value >= Math.min(rangeBoundary1, rangeBoundary2) && value <= Math.max(rangeBoundary1, rangeBoundary2);
            return result;
        },

        /**
         * To round floats like 16.294999999999998 after float calculations
         * @param {number} number
         * @param {number|undefined} precision
         * @returns {number}
         */
        roundFloat: function(number, precision) {
            precision = precision || 2;
            var extraPrecision = precision + 1;
            var firstStepRounded = Number(Math.round(number + 'e' + extraPrecision) + 'e-' + extraPrecision);

            return Number(Math.round(firstStepRounded + 'e' + precision) + 'e-' + precision);
        },

        /**
         * @param {number} n
         * @param {number} n2
         * @param {number} degree
         * @returns {number}
         */
        multiplication: function(n, n2, degree) {
            var multiplier = Math.pow(10, degree || 2);

            return parseInt(n * multiplier) * parseInt(n2 * multiplier) / Math.pow(multiplier, 2);
        },

        /**
         * @param {number|string} number
         * @returns {string}
         */
        formatNumber: function(number) {
            //replace by Intl extension
            return number.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
        },

        /**
         * @param {number} number
         * @returns {number}
         */
        convertInchToMillimeter: function(number) {
            return number * 25.4;
        },

        /**
         * @param {number} number
         * @param {string} currency
         * @returns {string}
         */
        formatPrice: function(number, currency) {
            // empty array as a locale to auto-detect
            let formatter = new Intl.NumberFormat([ONP.config.defaultLang], {
                style: 'currency',
                currency: currency
            });

            return formatter.format(number);
        },

        /**
         * @param {number} price
         * @param {number|null} vatRate
         * @return {number}
         */
        applyVat: function(price, vatRate) {
            if (vatRate === null || isNaN(vatRate) || isNaN(parseFloat(price))) {
                return price;
            }

            return this.roundFloat(price + price * vatRate / 100, 2);
        },

        /**
         * @param {string} name
         * @returns {string}
         */
        reduceFileName: function(name) {
            if (name.length > 30) {
                name = name.substring(0, 15) + '...' + name.substr(name.length - 15, 15);
            }

            return name;
        },

        /**
         * @see http://stackoverflow.com/q/7616461/940217
         * @param {string} string
         * @returns {number}
         */
        getStringHash: function(string) {
            var hash = 0,
                i,
                chr,
                len;
            if (string.length === 0) {
                return hash;
            }

            for (i = 0, len = string.length; i < len; i++) {
                chr = string.charCodeAt(i);
                hash = (hash << 5) - hash + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        },

        /**
         * Get credentials from browser, call the callback
         *
         * @callback callbackLogin
         * @callback callbackOnSuccessLogin
         * @callback fallback
         */
        sendPreparedCredentials: function(callbackLogin, callbackOnSuccessLogin, fallback) {
            navigator.credentials.get({ password: true }).then(function(credentials) {
                var token = $('.login-form-csrf-token').val();

                if (token && credentials instanceof PasswordCredential) {
                    var preparedCredentials = {
                        _username: credentials.id,
                        _csrf_token: token,
                        _password: credentials.password
                    };

                    callbackLogin(callbackOnSuccessLogin, preparedCredentials);
                } else {
                    if (fallback instanceof Function) {
                        fallback();
                    }
                }
            });
        }
    };
});
